import { render, staticRenderFns } from "./CartSectionWaiters.vue?vue&type=template&id=13259438&scoped=true"
import script from "./CartSectionWaiters.vue?vue&type=script&lang=js"
export * from "./CartSectionWaiters.vue?vue&type=script&lang=js"
import style0 from "./CartSectionWaiters.vue?vue&type=style&index=0&id=13259438&prod&scoped=true&lang=css"
import style1 from "./CartSectionWaiters.vue?vue&type=style&index=1&id=13259438&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "13259438",
  null
  
)

export default component.exports